import { Pipe, PipeTransform } from '@angular/core'
import { AuditReportLineRepairStatus } from '@wm-front/admin/graphql'

@Pipe({
  name: 'repairStatus',
  standalone: true,
})
export class RepairStatusPipe implements PipeTransform {
  /** Transform repair request status into localised string
   * @returns {string}
   * @param {RepairRequestState} value
   */

  public transform(value?: AuditReportLineRepairStatus): string {
    switch (value) {
      case AuditReportLineRepairStatus.RequestToCreate:
        return $localize`:Info Value | Value for the request to create status @@repairRequestStatusRequestToCreateLabel:Item without request`
      case AuditReportLineRepairStatus.OngoingRequest:
        return $localize`:Info Value | Value for the ongoing request status @@repairRequestStatusOngoingRequestLabel:In progress`
      case AuditReportLineRepairStatus.ReadyToBeFixed:
        return $localize`:Info Value | Value for the ready to be fixed status @@repairRequestStatusReadyToBeFixedLabel:Visit to be done`
      case AuditReportLineRepairStatus.WorkDone:
        return $localize`:Info Value | Value for the work done status @@repairRequestStatusWorkDoneLabel:Done`
      default:
        return $localize`:Info Value | Value for no status @@repairRequestStatusNoStatusLabel:No status`
    }
  }
}
